export default __webpack_public_path__ + "static/media/Espa.bac69eac.woff2";